import { render, staticRenderFns } from "./ResultatUebersicht.vue?vue&type=template&id=38f32d64&"
import script from "./ResultatUebersicht.vue?vue&type=script&lang=js&"
export * from "./ResultatUebersicht.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports